import { AbstractBaseComponent } from "../../shared/abstract-base.component";
import { Component, ViewChild,Output, EventEmitter } from '@angular/core';
import { ModalDirective } from "ngx-bootstrap/modal";
import { ApiRequestDto, ReportsService } from "../../api";
import { FacilitiesService } from "../../core";
import { DateTimeFormatter, LocalDate } from "@js-joda/core";
import { AbstractDownloadFileContentComponent } from "../../shared/download-file-content/abstract-download-file-content.component";


@Component({
    /* Component for displaying a Report Row. */
    selector: 'my-medication-fall-risk-modal',
    templateUrl: 'medication-fall-risk-modal.component.html'
})

export class MedicationFallRiskModal extends AbstractDownloadFileContentComponent {

    @ViewChild('recordsModal', {static: false}) public recordsModal: ModalDirective;

    constructor( private reportService: ReportsService, private facilityService: FacilitiesService){
        super();
    }

    title: string = "Generating Excel";
    modalBodyText: string = "Report generating to Excel";
    hideSpinner: boolean=true;

    show() {
        this.recordsModal.show();
    }

    generateExcel(){
         //this triggers the visual cue that works is been done
         this.hideSpinner = false;
         const requestParams: ApiRequestDto = { 
            OrgList: this.facilityService.selectedAsOrgList
        };
         this.reportService.reportsGetGeneratedMedFallRiskReport(requestParams).subscribe(
            (result) => {
                this.downloadFile(result, 'MedicationFallRisk.xls');
                this.closeModal();
            }
        );
    }    

    closeModal(){
        this.hideSpinner = true;
        this.recordsModal.hide();
        this.ngOnDestroy();
    }
}